import React, { useState } from 'react'

import { Select } from 'antd'

import { getMessage } from '../../../../../../util/IntlMessages'
import { useCustomFieldsContext } from '../../context/customFields'
import { useManageFieldRelationships } from '../../hooks/useManageFieldRelationships'
import { useManageField } from '../../hooks/useManageFields'
import { useManageGroup } from '../../hooks/useManageGroups'
import { useManagePositions } from '../../hooks/useManagePositions'
import { RemoveRelationshipsModal } from '../RemoveRelationshipsModal'

import './styles.less'

export function GroupsAndFieldsOrder() {
  const [relationshipsModal, setRelationshipsModal] = useState(null)

  const { groupIds, currentGroupId } = useCustomFieldsContext()

  const { selectedFieldId, currentField, getFieldById } = useManageField()

  const { hasRelationships } = useManageFieldRelationships({ fieldId: selectedFieldId })

  const { positions, updateFieldPosition } = useManagePositions()

  const { updateFieldGroup } = useManageGroup()

  const handleChangeGroup = ({ fieldId, targetGroupId, currentGroupId }) => {
    const currentGroupName = getFieldById(currentGroupId)?.fieldName
    const targetGroupName = getFieldById(targetGroupId)?.fieldName
    const currentFieldName = getFieldById(fieldId).fieldName

    if (hasRelationships) {
      setRelationshipsModal({
        onOk: () => {
          setRelationshipsModal(null)
          updateFieldGroup({ fieldId, targetGroupId, currentGroupId })
        },
        message: !targetGroupId
          ? getMessage('removeFieldOfGroup', currentFieldName, currentGroupName)
          : getMessage('addFieldToGroup', currentFieldName, targetGroupName)
      })
    } else {
      updateFieldGroup({ fieldId, targetGroupId, currentGroupId })
    }
  }

  return (
    <div className="groupsAndFieldsOrder">
      <RemoveRelationshipsModal
        visible={!!relationshipsModal}
        message={relationshipsModal?.message}
        onCancel={() => setRelationshipsModal(null)}
        onOk={relationshipsModal?.onOk}
        removeAll
      />

      <div className="horizontal-line nav-item-separator groupsAndFieldsOrder__divider" />

      <div>
        <label>{getMessage('customFieldGroupForm')}</label>
        <Select
          allowClear
          value={currentGroupId}
          onChange={(targetGroupId) => handleChangeGroup({ fieldId: selectedFieldId, targetGroupId, currentGroupId })}
        >
          {groupIds?.map((groupId) => (
            <Select.Option value={groupId} key={groupId} label={getFieldById(groupId)?.fieldName}>
              {getFieldById(groupId)?.fieldName}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div>
        <label>{getMessage('customFieldOrderingForm')}</label>
        <Select
          showSearch
          value={currentField?.fieldRow}
          onChange={(targetFieldRow) => updateFieldPosition({ fieldId: selectedFieldId, targetFieldRow })}
          filterOption={(input, option) => option.props.label.startsWith(input)}
        >
          {positions?.map((fieldRow) => (
            <Select.Option value={fieldRow} key={fieldRow} label={String(fieldRow)}>
              {String(fieldRow)}
            </Select.Option>
          ))}
        </Select>
      </div>
    </div>
  )
}
